import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pd",
  "use": "icon-pd-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-pd\"><defs><style type=\"text/css\"></style></defs><path d=\"M817.4 64.1H206.5c-33.3 0-60.3 26.6-61 59.8h4.2c-1.4 0-2.7 0.1-4.2 0.2v774.7c0 33.7 27.4 61.1 61.1 61.1h610.8c33.6 0 61-27.4 61-61.1V124c-0.7-33.3-27.8-59.9-61-59.9zM530 726c0 17.6-14.4 32-32 32H352c-17.6 0-32-14.4-32-32s14.4-32 32-32h146c17.6 0 32 14.4 32 32z m90-214c0 17.6-14.4 32-32 32H352c-17.6 0-32-14.4-32-32s14.4-32 32-32h236c17.6 0 32 14.4 32 32z m84-214c0 17.6-14.4 32-32 32H352c-17.6 0-32-14.4-32-32s14.4-32 32-32h320c17.6 0 32 14.4 32 32z\" fill=\"#303133\" p-id=\"2657\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/pd.svg
// module id = 2JU6
// module chunks = 16